import React from 'react';
import {
  List,
  Create,
  Show,
  Edit,
  Tab,
  Datagrid,
  DateInput,
  TextField,
  EmailField,
  DateField,
  TextInput,
  BooleanInput,
  SimpleForm,
  BooleanField,
  ReferenceField,
  SelectInput,
  TabbedForm,
  FormTab,
  ReferenceManyField,
  TabbedShowLayout,
  required,
} from 'react-admin';
import Icon from '@material-ui/icons/AccountBox';
import Title from './Title';
import { ListFilter, ListActions } from './ListActions';

const validateCustomer = values => {
  const errors = {};
  if (values.country_code && !values.country_code.startsWith('+')) {
    errors.country_code = ['Country Code should start with +'];
  }
  return errors;
};

export const CustomerIcon = Icon;

export const CustomerList = props => (
  <List {...props} filters={<ListFilter />} actions={<ListActions />} bulkActionButtons={false}>
    <Datagrid>
      <TextField source="salutation" />
      <TextField source="first_name" />
      <TextField source="last_name" />
      <DateField source="birthday" />
      <EmailField source="email" />
      <TextField source="country_code" />
      <TextField source="mobile" />
      <BooleanField source="active" />
      <TextField source="autoline_id" label="Autoline ID" />
      <DateField label="Accepted T&C" showTime={true} source="accepted_at" />
      <DateField source="last_login" showTime={true} />
    </Datagrid>
  </List>
);

export const CustomerShow = props => (
  <Show {...props}>
    <TabbedShowLayout>
      <Tab label="Information">
        <TextField source="salutation" />
        <TextField source="first_name" />
        <TextField source="last_name" />
        <TextField source="birthday" />
        <TextField source="email" />
        <TextField source="country_code" placeholder="+" />
        <TextField source="mobile" />
        <BooleanField source="active" />
        <TextField source="autoline_id" />
        <DateField label="Accepted T&C" showTime={true} source="accepted_at" />
        <DateField label="Created date" showTime={true} source="created_at" />
        <DateField label="Updated date" showTime={true} source="updated_at" />
      </Tab>
      <Tab label="Cars">
        <ReferenceManyField
          addLabel={false}
          filter={{ is_family_car: false }}
          sort={{ field: 'reg_no', order: 'DESC' }}
          reference="cars"
          target="user_id"
        >
          <Datagrid>
            <TextField source="reg_no" />
            <DateField source="reg_date" />
            <TextField source="chasis_no" label="Chassis no" />
            <ReferenceField label="Car Brand" source="car_brand.id" reference="brands" allowEmpty={true}>
              <TextField source="name" />
            </ReferenceField>
            <ReferenceField label="Car Model" source="car_model.id" reference="models" allowEmpty={true}>
              <TextField source="name" />
            </ReferenceField>
            <ReferenceField
              label="Sales Consultant"
              source="sales_advisor.id"
              reference="sales_advisors"
              allowEmpty={true}
            >
              <TextField source="full_name" />
            </ReferenceField>
            <ReferenceField
              label="Service Consultant"
              source="service_consultant.id"
              reference="service_consultants"
              allowEmpty={true}
            >
              <TextField source="full_name" />
            </ReferenceField>
            <DateField source="last_service_date" />
          </Datagrid>
        </ReferenceManyField>
      </Tab>
      <Tab label="Family Cars">
        <ReferenceManyField
          addLabel={false}
          filter={{ is_family_car: true }}
          sort={{ field: 'reg_no', order: 'DESC' }}
          reference="cars"
          target="user_id"
        >
          <Datagrid>
            <TextField source="relationship" />
            <TextField source="relationship_name" label="Name" />
            <TextField source="relationship_mobile" label="Mobile No." />
            <TextField source="reg_no" />
            <ReferenceField label="Car Brand" source="car_brand.id" reference="brands">
              <TextField source="name" />
            </ReferenceField>
            <ReferenceField label="Car Model" source="car_model.id" reference="models">
              <TextField source="name" />
            </ReferenceField>
            <DateField source="last_service_date" />
          </Datagrid>
        </ReferenceManyField>
      </Tab>
    </TabbedShowLayout>
  </Show>
);

export const CustomerCreate = props => (
  <Create title={'New Customer'} {...props}>
    <SimpleForm validate={validateCustomer}>
      <SelectInput
        source="salutation"
        choices={[{ id: 'Mr', name: 'Mr' }, { id: 'Mrs', name: 'Mrs' }, { id: 'Ms', name: 'Ms' }]}
        validate={required()}
      />
      <TextInput source="first_name" validate={required()} />
      <TextInput source="last_name" validate={required()} />
      <DateInput source="birthday" validate={required()} />
      <TextInput source="email" validate={required()} />
      <TextInput source="country_code" validate={required()} />
      <TextInput source="mobile" validate={required()} />
      <BooleanInput source="active" />
    </SimpleForm>
  </Create>
);

export const CustomerEdit = props => (
  <Edit title={<Title />} {...props}>
    <TabbedForm validate={validateCustomer}>
      <FormTab label="Information">
        <SelectInput
          source="salutation"
          choices={[{ id: 'Mr', name: 'Mr' }, { id: 'Mrs', name: 'Mrs' }, { id: 'Ms', name: 'Ms' }]}
          validate={required()}
        />
        <TextInput source="first_name" validate={required()} />
        <TextInput source="last_name" validate={required()} />
        <DateInput source="birthday" validate={required()} />
        <TextInput source="email" validate={required()} />
        <TextInput source="country_code" validate={required()} placeholder="+" />
        <TextInput source="mobile" validate={required()} />
        <BooleanInput source="active" />
      </FormTab>
      <FormTab label="Cars">
        <ReferenceManyField
          addLabel={false}
          filter={{ is_family_car: false }}
          sort={{ field: 'reg_no', order: 'DESC' }}
          reference="cars"
          target="user_id"
        >
          <Datagrid>
            <TextField source="reg_no" />
            <DateField source="reg_date" />
            <TextField source="chasis_no" label="Chassis no" />
            <ReferenceField label="Car Brand" source="car_brand.id" reference="brands">
              <TextField source="name" />
            </ReferenceField>
            <ReferenceField label="Car Model" source="car_model.id" reference="models">
              <TextField source="name" />
            </ReferenceField>
            <ReferenceField label="Sales Consultant" source="sales_advisor.id" reference="sales_advisors">
              <TextField source="full_name" />
            </ReferenceField>
            <ReferenceField label="Service Consultant" source="service_consultant.id" reference="service_consultants">
              <TextField source="full_name" />
            </ReferenceField>
            <DateField source="last_service_date" />
          </Datagrid>
        </ReferenceManyField>
      </FormTab>
      <FormTab label="Family Cars">
        <ReferenceManyField
          addLabel={false}
          filter={{ is_family_car: true }}
          sort={{ field: 'reg_no', order: 'DESC' }}
          reference="cars"
          target="user_id"
        >
          <Datagrid>
            <TextField source="relationship" />
            <TextField source="relationship_name" label="Name" />
            <TextField source="relationship_mobile" label="Mobile No." />
            <TextField source="reg_no" />
            <ReferenceField label="Car Brand" source="car_brand.id" reference="brands">
              <TextField source="name" />
            </ReferenceField>
            <ReferenceField label="Car Model" source="car_model.id" reference="models">
              <TextField source="name" />
            </ReferenceField>
            <DateField source="last_service_date" />
          </Datagrid>
        </ReferenceManyField>
      </FormTab>
    </TabbedForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/containers/Customer/index.js